import { Link } from "@inertiajs/react"
import type { ReactNode } from "react"
import Flash from "@/components/Flash"
import Logo from "@/components/Logo"
import TokenBanner from "@/components/TokenBanner"
import UserMenu from "@/components/UserMenu"
import useCurrentUser from "@/lib/useCurrentUser"

export default function AppLayout({ children }: { children: ReactNode }) {
  const user = useCurrentUser()

  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:rounded-control focus:bg-white focus:p-2 dark:focus:bg-gray-950"
      >
        Skip to content
      </a>
      <header className="surface sticky top-0 z-10">
        <div className="mx-auto flex h-16 max-w-page items-center justify-between gap-3 px-4">
          <Link href="/" className="flex items-center gap-2 rounded-control font-semibold">
            <Logo className="size-7" />
            Status Minder
          </Link>
          {user && <UserMenu user={user} />}
        </div>
      </header>
      {user?.has_token && <TokenBanner />}
      <main id="main" className="mx-auto max-w-page px-4 pt-2 pb-16">
        <Flash />
        {children}
      </main>
    </>
  )
}
